<accordion
  class="accordion-item-container"
  [ngClass]="customClass">
  <accordion-group
    [panelClass]="customClass"
    [isOpen]="accordionOpen"
    (isOpenChange)="changeStatus($event)"
    [ngClass]="customClass"
  >
    <div class="accordion-item-heading" accordion-heading>
      <div class="required-documents-item-image-wrapper col-xs-2"> </div>
      <div
        class="required-documents-item-name accordion-item-title"
        *ngIf="title"
      >
        {{ title }}
      </div>

      <div class="required-documents-item-icon-wrapper col-xs-2">
        <em class="required-documents-item-icon" [@indicatorRotate]="accordionOpen ? 'expanded' : 'collapsed'"></em>
      </div>
    </div>
    <ng-content></ng-content>
  </accordion-group>
</accordion>
